<template>
  <v-container fluid grid-list-xl class="pt-0">
    <v-layout justify-center wrap>
      <!-- <v-flex :proposal="proposal"
                xs12
                md12
            > -->
      <v-flex xs12 md12 class="pt-0">
        <cpn-customer-form @updateUcList="updateUcList"></cpn-customer-form>
      </v-flex>
      <v-flex xs12 md12>
        <cpn-customer-unit-list
          @autoQualification="autoQualification"
          ref="ucList"
        ></cpn-customer-unit-list>
      </v-flex>
      <!-- <v-flex
                xs12
                md12
            >
                <cpn-customer-qualification-list/>
            </v-flex> -->
      <v-flex xs12 md12>
        <!-- <cpn-customer-unit-form :proposal="proposal"></cpn-customer-unit-form> -->
        <cpn-customer-unit-form
          ref="ucForm"
          @getUcs="getUcs"
          v-if="consumerUnitFormType === 'manual'"
        />
        <cpn-customer-unit-auto-form v-else />
      </v-flex>
    </v-layout>
    <!--
        <v-flex
        xs12
        md12
        >
            <cpn-user-list :users="users"></cpn-user-list>
        </v-flex>
        -->
  </v-container>
</template>
<script>
// import userList from '../components/user/userList'
// import userUpload from '../components/user/userUpload'
// import { getuser } from '../services/users'
import CustomerForm from "../components/customer/CustomerForm";
import CustomerUnitList from "../components/customer/CustomerUnitList.vue";
// import CustomerQualificationList from '../components/customer/CustomerQualificationList.vue';
import CustomerFormUnit from "../components/customer/CustomerFormUnit.vue";
import CustomerAutoFormUnit from "../components/customer/CustomerAutoFormUnit.vue";
import { eventBus } from "../main";
import { GET_USER_DETAIL } from "../graphql/users";
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
      // users: [],
      id: "",
      user: {},
      //proposal: {},
      loading: false,
      type: "manual",
    };
  },
  components: {
    // cpnuserList: userList,
    cpnCustomerForm: CustomerForm,
    cpnCustomerUnitList: CustomerUnitList,
    // cpnCustomerQualificationList: CustomerQualificationList,
    cpnCustomerUnitForm: CustomerFormUnit,
    cpnCustomerUnitAutoForm: CustomerAutoFormUnit,
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.fecthuser(this.id);
    }
  },
  computed: {
    ...mapGetters("members", ["consumerUnitFormType"]),
  },
  methods: {
    async fecthuser(id) {
      this.loading = true;
      this.$apollo
        .query({
          // gql query
          query: GET_USER_DETAIL,
          // Reactive parameters
          variables: {
            // Use vue reactive properties here
            customer_id: id,
          },
        })
        .then((user) => {
          // Seta as faturas no eventBus para o outro Componente
          this.user = user.data.user;
          eventBus.$emit("userSelected", this.user);
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    autoQualification(partner_origin) {
      this.$refs.ucForm.setAutoQualification(partner_origin);
    },
    getUcs() {
      this.$refs.ucList.getUcs();
    },
    updateUcList(param) {
      this.$refs.ucList.getUcList(param);
      this.$refs.ucForm.clearForm();
      this.$refs.ucForm.setUser(param);
    },
  },
};
</script>
